var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftbite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.5,221c3.8,6,10.4,8,16.9,11.2c4.9-1,9.8-3.5,13.1-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,210c-1.2-4.5-2-9.1-3.6-13.5c-1.2-3.1-2.2-6.9-6.9-7.1c-4.7-0.2-8.2,1.6-10.5,5.6 c-2.6,4.5-6.1,12.9-8.5,17.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,229.5c1.5,8.3,1.3,17,6,24.5c3.8,6,7.1,5.7,11.6,0.1c4.1-5.1,4.4-10.3,2.8-16.1c-0.7-2.5-0.3-5-0.5-7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.5,237.7c-0.7,1.8-1.5,5.9-2,7.8c-1.8,8-6.2,13.5-14,16.6c-7.9,3.2-9.8,0.6-12.2-5c-1-2.4-1.9-5.1-1.9-7.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,194c-1.5-4.9-0.8-10.4-3.9-15.1c-4.1-6.3-6.1-4.6-10.1-1.4c-5.1,4.1-7.8,10-11,15.5 c-4.7,8.1-8.6,16.6-11.5,25.5c-1.5,4.5-0.6,6.7,4,7.4c8.1,1.3,16.3,4.6,24.5,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.5,224c-1.6,4.2-3.4,8.1-7.9,9.7c2,3,3.6,5.1,4.9,7.4c4.6,8.4,11.1,12.9,21,11.5 c10.9-1.6,19.6-3,22.1-16.1c1.4-7.1,6.2-13.3,4.9-20.9c-0.7-4.7-1.7-9.1-4.6-13c-3-4.1-7.3-6-12-5.9c-10.4,0.2-21.7,1.7-27.1,15.4 c-2.3,5.8-2,11.3,2.1,14.5c7.3,5.7,11.8,6.9,18,2.6c1.3-0.9,2.4-2,3.9-2.8c2.4-1.3,4.2-1.4,5.5,0.7c2.2,3.7,5.3,4.2,9.1,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.5,212c-1.9-2.8-2.3-6.1-3.9-9.1c-6.9-13-23.1-14.9-32.1-3.4c-2.7,3.4-5,7-7.5,10.5 c-1.6,2.2-1.2,11.3,0.5,13.5c4.4,5.6,8.2,7,13.5,5c1.7-0.6,3.3-1.6,5-1.9c2.2-0.4,4.4-0.1,5.5,2.4c2.3,5.1,6.4,6.3,11.5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,217.5c3.3,3.2,6.8,6.2,10,9.5c2.1,2.3,4.5,3.6,7.6,3.9c3.1,7,5.2,14.3,7.6,21.5c1.6,4.7,6.2,5.7,10.9,5.5 c5-0.2,7-4,8.5-8c1.9-5.3,4.4-12.6,6-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.5,228.5c2.6,9.9,3.9,20.3,9.1,29c6.7,0.1,7.4-5.1,9.9-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.5,226.5c1.3,8.5,3.6,16.8,7.1,24.7c3-1.5,4.2-2.5,3.2-6.3c-1.5-5.8-3.4-11.5-4.3-17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154,222.5c4.3,6.8,10.6,9.3,18.5,9.1c3.1-0.1,5.2-1.7,7.5-3.1c5.8-3.5,10.4-8.1,12.1-15 c0.3-1.1,0.7-2.3,0.3-3c-3.2-5.8-2.1-11.9-1.9-18c0.2-6.6-1.2-12.6-8-15.4c-6.6-2.8-12.1,0.3-16.9,4.5c-4.6,3.9-6.6,9.7-10,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.5,232c2.3,7.3,4.9,14.6,6.9,22c1.2,4.5,3.2,7.9,8.1,8.4c4.7,0.5,8.4-1.4,11-5.4c3.9-6.1,5.3-13.1,6.9-20 c0.2-0.8,0.5-1.5,1.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.5,234c1.9,2.7,1.6,6.1,3,9c2.4,4.8,5,8.7,11,10.2c7.2,1.8,14.4,1.6,21.5,1.2c6.3-0.4,12.4-7.7,13.5-14.9 c0.2-1.1-0.2-2.3,1-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,182c-3-2.5-0.2-7.1-3.6-9.5c-2.3-0.2-3.5,1.6-4.9,3c-10,10.4-16.8,22.6-18.9,37 c-1.3,8.6,1.4,11.4,8.4,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.5,221c-3.5,5.2-9.8,6.2-14.5,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153,222c-1.8-7-0.2-13.8,1.7-20.4c0.7-2.4,0.9-4.7,0.1-6.5c-2.3-5.2-3.3-11.1-7.4-15.6 c-3.9-4.3-6.5-4.1-10,0.5c-3.5,4.7-5.5,10.4-7.1,15.6c-2.4,7.9-6.1,15.3-8,23.4c-1.6,7-0.8,9.2,6.1,10c4.6,0.5,9.3,0.7,14,0.5 c4.4-0.2,7.4-3.1,10-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,249.5c1.1,1.6,2.1,3.2,3.3,4.9c2.1-0.5,1.8-3.2,3.2-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226,220c0-0.3,0-0.7,0-1c0.5-7-1.6-13.7-2.4-20.5c-0.5-3.7-1.4-7.3-3.2-10.4c-4.2-7.3-12.6-6.7-17.8,1 c-1.9,2.7-3.3,5.6-4.2,8.9c-1.1,4.2-2.8,8.4-5.4,12"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftbite);
export default __webpack_public_path__ + "static/media/leftbite.2071f3433cac2d650f33c636629bd398.svg";
export { ForwardRef as ReactComponent };